<template>
  <div class="nav-wrapper">
    <div class="experience-container">
      <div class="form-section">
        <div class="business-form">
          <BackButton @back="$emit('back')" />
          <h1 class="main-title">{{ $t("compliance.title") }}</h1>
          <p class="subtitle">{{ $t("compliance.subtitle") }}</p>

          <div class="compliance-card">
            <h3 class="compliance-card-title">{{ $t("compliance.whatToKnow") }}</h3>
            <ul class="benefits-list">
              <li>
                <div class="check-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20 6L9 17L4 12"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <span>{{ $t("compliance.benefits.deadlines") }}</span>
              </li>
              <li>
                <div class="check-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20 6L9 17L4 12"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <span>{{ $t("compliance.benefits.amendments") }}</span>
              </li>
              <li>
                <div class="check-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20 6L9 17L4 12"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <span>{{ $t("compliance.benefits.compliance") }}</span>
              </li>
            </ul>

            <div class="compliance-options">
              <label class="compliance-option">
                <input
                  type="radio"
                  v-model="worryFreeCompliance"
                  :value="true"
                  class="radio-input"
                  name="compliance"
                />
                <div class="option-content">
                  <span class="radio-custom"></span>
                  <span class="option-text">{{
                    $t("compliance.options.yes")
                  }}</span>
                </div>
              </label>

              <label class="compliance-option">
                <input
                  type="radio"
                  v-model="worryFreeCompliance"
                  :value="false"
                  class="radio-input"
                  name="compliance"
                />
                <div class="option-content">
                  <span class="radio-custom"></span>
                  <span class="option-text">{{
                    $t("compliance.options.no")
                  }}</span>
                </div>
              </label>
            </div>

            <button class="next-button" @click="handleNext">
              {{ $t("compliance.next") }}
            </button>
          </div>
        </div>
      </div>

      <div class="info-section">
        <div class="info-content">
          <h2 class="info-title">{{ $t("compliance.infoTitle") }}</h2>
          <div class="video-container">
            <iframe
              src="https://www.youtube.com/embed/3lLCWiW0iBQ"
              title="Registered Agent Video"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              class="video-iframe"
            ></iframe>
          </div>

          <h3 class="info-subtitle">
            {{ $t("compliance.infoSubtitle") }}
          </h3>
          <p class="info-text">{{ $t("compliance.infoText") }}</p>

          <div class="illustration-container">
            <img
              src="@/assets/compliance-illustration.png"
              alt="Compliance Illustration"
              class="business-illustration"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BackButton from "./BackButton.vue";

export default {
  name: "Compliance",
  components: {
    BackButton,
  },
  data() {
    return {
      worryFreeCompliance: true,
    };
  },
  methods: {
    handleNext() {
      this.$emit("next", {
        worryFreeCompliance: this.worryFreeCompliance,
      });
    },
  },
};
</script>

<style scoped>
@import "@/styles/CustomerBusiness.css";

</style>
